module.exports = __webpack_public_path__ + "static/img/公众号.19a384a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/公众号.jpg
// module id = CMT0
// module chunks = 20